/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Cell } from "react-table";
import { FlexContainer } from "~/components";
import { JiraProjectDelete } from "~/components/JiraProjects/JiraProjectDelete";
import { JiraProjectEdit } from "~/components/JiraProjects/JiraProjectEdit";
import { JiraProject } from "~/models/jiraProject";

export const JiraProjectsListColumns = (
  fetchJiraProjects: () => void,
  canEdit: boolean
) => [
  {
    Header: "JIRA Code",
    accessor: "code",
    disableSortBy: true,
    width: "35%",
  },
  {
    Header: "Reporting Start Date",
    accessor: "reportingStartDate",
    disableSortBy: true,
  },
  {
    Header: "Reporting End Date",
    accessor: "reportingEndDate",
    disableSortBy: true,
  },
  {
    Header: () => <div style={{ textAlign: "right" }}>Actions</div>,
    accessor: "actions",
    disableSortBy: true,
    Cell: ({ row }: Cell<JiraProject>) => {
      return (
        <>
          {canEdit && (
            <FlexContainer>
              <JiraProjectEdit
                refetch={fetchJiraProjects}
                jiraProjectId={row?.original?.code || ""}
              />
              <JiraProjectDelete
                deleteCallback={fetchJiraProjects}
                initialValues={row?.original}
              />
            </FlexContainer>
          )}
        </>
      );
    },
  },
];
